import { createDecorator } from '../../instantiation/common/instantiation.js';
const IExtensionsScannerService = ( createDecorator('IExtensionsScannerService'));
export { IExtensionsScannerService };
